<template>
    <div class="finish-page">
        <header class="finish-header">
            <picture>
                <source media="(max-width: 600px)" :srcset="headerMobile">
                <img :src="headerDesktop" alt="Southbridge — Seguro Oncológico IRAM">
            </picture>
        </header>

        <main class="finish-content">
            <h1 class="finish-title">¡Listo{{ userData.name ? ' ' + capitalizeName(userData.name) : '' }}!</h1>
            <p class="finish-subtitle">Tu seguro oncológico ha sido contratado con éxito.</p>

            <section class="finish-summary" aria-labelledby="finish-summary-title">
                <h2 id="finish-summary-title">Resumen de tu contratación</h2>
                <dl class="finish-details">
                    <div>
                        <dt>Contratante:</dt>
                        <dd>{{ summary.contractor }}</dd>
                    </div>
                    <div>
                        <dt>Rut:</dt>
                        <dd>{{ summary.rut }}</dd>
                    </div>
                    <div>
                        <dt>Teléfono:</dt>
                        <dd>{{ summary.phone }}</dd>
                    </div>
                    <div>
                        <dt>Email:</dt>
                        <dd class="finish-email">{{ summary.email }}</dd>
                    </div>
                    <div>
                        <dt>Tipo de plan:</dt>
                        <dd>{{ summary.plan }}</dd>
                    </div>
                </dl>
                <div class="finish-payment">
                    <span>Pago mensual:</span>
                    <span><strong>${{ summary.premiumPesos }}</strong> / <small>UF {{ summary.premiumUf }}</small></span>
                </div>
            </section>

            <div class="finish-confirmation">
                <p class="finish-policy">Recibirás tu póliza en tu correo.</p>
                <p>Gracias por confiar en nosotros.</p>
            </div>

            <div class="finish-repurchase">
                <img :src="groupIcon" alt="" width="28" height="28">
                <p>¿Te gustaría contratar este seguro para alguien más?</p>
                <button type="button" class="finish-link" @click="returnPage(0)">
                    Volver a contratar <span class="finish-chevron" aria-hidden="true"></span>
                </button>
            </div>

            <p class="finish-reminder">
                Si no recibiste tu póliza en tu correo,<br>
                recuerda revisar en la bandeja de spam, promociones y no deseados.
            </p>
        </main>

        <footer class="finish-footer">
            <div class="finish-help">
                <div class="finish-help-inner">
                    <section class="finish-help-item">
                        <img :src="shieldIcon" alt="" class="finish-help-icon">
                        <div>
                            <h2>Conoce más seguros</h2>
                            <p>Explora más seguros en nuestra<br class="finish-desktop-break"> web y protege lo que más importa.</p>
                            <button type="button" class="finish-link" @click="returnPage(1)">
                                Ver más seguros <span class="finish-chevron" aria-hidden="true"></span>
                            </button>
                        </div>
                    </section>
                    <section class="finish-help-item">
                        <img :src="chromeIcon" alt="" class="finish-help-icon">
                        <div>
                            <h2>¿Necesitas ayuda?</h2>
                            <p>Si tienes problemas, comunícate<br class="finish-desktop-break"> con nosotros aquí:</p>
                            <button type="button" class="finish-link" @click="returnPage(2)">
                                Atención al cliente <span class="finish-chevron" aria-hidden="true"></span>
                            </button>
                        </div>
                    </section>
                </div>
            </div>
            <div class="finish-brand">
                <img :src="fairfaxLogo" alt="a FAIRFAX Company">
            </div>
        </footer>
    </div>
</template>

<script>
import ShieldService from "../services/shield.service";
import headerDesktop from "@/assets/images/barraTitulo.svg";
import headerMobile from "@/assets/images/barraFondoMobile.svg";
import shieldIcon from "@/assets/images/shield.png";
import groupIcon from "@/assets/images/group.png";
import chromeIcon from "@/assets/images/chrome.png";
import fairfaxLogo from "@/assets/images/LogoFairfax.png";

export default {
    data() {
        return {
            headerDesktop,
            headerMobile,
            shieldIcon,
            groupIcon,
            chromeIcon,
            fairfaxLogo,
            success: null,
            load: false,
            planData: null,
            userData: {
                name: null,
                email: null,
            },
            servicesData: null,
            insuranceConsult: null,
            activeCampaingUse: process.env.VUE_APP_ACTIVE_CAMPAIGN ? process.env.VUE_APP_ACTIVE_CAMPAIGN : 'FALSE',
        }
    },
    computed: {
        summary() {
            const insurance = (this.insuranceConsult && this.insuranceConsult.insuranceData) || {};
            const plan = insurance.plan || {};

            return {
                contractor: [this.userData.name, this.userData.surname]
                    .filter(Boolean).map(this.capitalizeName).join(' ') || '—',
                rut: this.userData.rut || '—',
                phone: '+56 9' + (this.userData.phoneNumber || '—'),
                email: this.userData.email || '—',
                plan: plan.cantBenf.includes('familiar') ? 'Familiar' : 'Individual' || '—',
                premiumPesos: this.formatAmount(plan.values[0].priceCLP, 0),
                premiumUf: this.formatAmount(plan.values[0].price, 20),
            };
        },
    },
    methods: {
        capitalizeName(name) {
            return name ? name.charAt(0).toUpperCase() + name.slice(1) : '';
        },
        formatAmount(value, maximumFractionDigits) {
            if (value === null || value === undefined || String(value).trim() === '') return '—';
            const amount = Number(value);
            return Number.isFinite(amount)
                ? amount.toLocaleString('es-CL', { maximumFractionDigits })
                : '—';
        },
        returnPage(index) {
            sessionStorage.removeItem('userData');
            sessionStorage.removeItem('benefData');
            sessionStorage.removeItem('servicesData');
            sessionStorage.removeItem('planData');

            if (index == '0') {
                this.$router.push({ path: '/og/inicio' })
            } else if (index == '1') {
                window.location.href = 'https://southbridgeseguros.cl/';
            } else if (index == '2') {
                window.location.href = 'https://southbridgeseguros.cl/contacto';
            }
        }
    },
    async mounted() {
        const query = this.$route.query;
        document.body.setAttribute('data-sku', 'ONC-009-SCS');
        if (query) {
            if (query.success === "true") {
                const insuranceConsult = await ShieldService.getRunWayPaymentData(query.id);
                console.log(insuranceConsult)
                this.insuranceConsult = insuranceConsult;
                this.userData = (insuranceConsult && insuranceConsult.personData) || {};
                this.success = true;

                if (this.activeCampaingUse == 'TRUE') {
                    await ShieldService.updateContactActiveCampain(null, this.planData, this.servicesData, 3);
                }

                this.load = true;
            } else if (query.success === "false") {
                this.success = false;
            }
        }
    },
}
</script>

<style scoped>
.finish-page {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background: #fff;
    color: #080d62;
    font-family: 'Poppins', sans-serif;
    font-size: 13.8px;
    font-weight: 400;
}

.finish-header img {
    display: block;
    width: 100%;
    height: auto;
}

.finish-content {
    flex: 1;
    padding: 59.8px 23px;
    text-align: center;
}

.finish-title {
    margin: 0 0 13.8px;
    color: #080d62;
    font-size: 20.7px;
    font-weight: 500;
    line-height: 32.2px;
}

.finish-page .finish-subtitle {
    margin: 0 0 16.1px;
    color: #333;
    font-size: 15px;
    line-height: 25.3px;
}

.finish-summary {
    width: 100%;
    max-width: 404.8px;
    margin: 0 auto;
    padding: 11.5px 13.8px;
    border: 1px solid #e5e5e5;
    border-radius: 5.8px;
    text-align: left;
}

.finish-summary h2 {
    margin: 0 3.5px 13.8px;
    padding-bottom: 8px;
    border-bottom: 1px solid #eee;
    font-size: 15px;
    font-weight: 500;
    line-height: 23px;
}

.finish-details {
    margin: 0;
    padding: 0 16.1px;
}

.finish-details > div {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 13.8px;
    padding: 3.5px 0;
    line-height: 18.4px;
}

.finish-details dt {
    flex-shrink: 0;
}

.finish-details dd {
    min-width: 0;
    margin: 0;
    color: #111;
    text-align: right;
    overflow-wrap: anywhere;
}

.finish-details .finish-email {
    color: #080d62;
}

.finish-payment {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 4.6px 13.8px;
    margin-top: 10.4px;
    padding: 8px 16.1px;
    border-radius: 5.8px;
    background: #edf1ff;
    font-weight: 500;
    line-height: 18.4px;
}

.finish-payment strong {
    font-weight: 600;
}

.finish-payment small {
    font-size: 11.5px;
    font-weight: 400;
}

.finish-confirmation {
    margin-top: 20.7px;
    color: #333;
    font-size: 15px;
    line-height: 27.6px;
}

.finish-page .finish-confirmation p {
    margin: 0;
}

.finish-policy {
    color: #004bff;
    font-weight: 500;
}

.finish-repurchase {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 13.8px;
    width: fit-content;
    max-width: 100%;
    margin: 48.3px auto 0;
    padding: 5.8px 18.4px;
    border-radius: 5.8px;
    background: #edf1ff;
    font-weight: 500;
}

.finish-repurchase img {
    width: 32.2px;
    height: 32.2px;
    flex-shrink: 0;
    object-fit: contain;
}

.finish-page .finish-repurchase p {
    margin: 0;
}

.finish-link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 16.1px;
    padding: 4.6px 0;
    border: 0;
    background: transparent;
    color: #004bff;
    font: inherit;
    font-weight: 500;
    line-height: 23px;
    text-align: left;
    cursor: pointer;
}

.finish-repurchase .finish-link {
    flex-shrink: 0;
}

.finish-link:hover {
    text-decoration: underline;
}

.finish-link:focus-visible {
    outline: 2px solid #004bff;
    outline-offset: 4.6px;
    border-radius: 2px;
}

.finish-chevron {
    display: inline-block;
    width: 5.8px;
    height: 5.8px;
    border-top: 1px solid currentColor;
    border-right: 1px solid currentColor;
    transform: rotate(45deg);
}

.finish-page .finish-reminder {
    margin: 36.8px 0 0;
    color: #333;
    font-size: 13.8px;
    line-height: 23px;
}

.finish-help {
    padding: 23px;
    background: #edf1ff;
}

.finish-help-inner {
    display: grid;
    grid-template-columns: 1fr 1fr;
    max-width: 736px;
    margin: 0 auto;
}

.finish-help-item {
    display: flex;
    align-items: flex-start;
    gap: 13.8px;
    padding: 3.5px 23px 0 0;
}

.finish-help-item + .finish-help-item {
    justify-content: flex-end;
    padding: 3.5px 0 0 46px;
    border-left: 1px solid #d8dbe5;
}

.finish-help-icon {
    flex-shrink: 0;
    width: 66.7px;
    height: 73.6px;
    object-fit: contain;
}

.finish-help-item h2 {
    margin: 0 0 6.9px;
    font-size: 13.8px;
    font-weight: 500;
    line-height: 23px;
}

.finish-page .finish-help-item p {
    margin: 0 0 4.6px;
    color: #111;
    line-height: 20.7px;
}

.finish-brand {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 25.3px;
    background: #000;
}

.finish-brand img {
    display: block;
    width: 172.5px;
    height: auto;
    filter: brightness(0) invert(1);
}

@media (min-width: 691px) {
    .finish-page {
        min-height: 100dvh;
    }

    .finish-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-evenly;
        gap: 8px;
        padding: clamp(4px, 1.5vh, 16px) 23px;
    }

    .finish-title,
    .finish-page .finish-subtitle,
    .finish-summary,
    .finish-confirmation,
    .finish-repurchase,
    .finish-page .finish-reminder {
        flex-shrink: 0;
        margin: 0;
    }
}

@media (min-width: 691px) and (max-height: 800px) {
    .finish-help {
        padding-top: 8px;
        padding-bottom: 8px;
    }

    .finish-summary h2 {
        margin-bottom: 8px;
    }

    .finish-details > div {
        padding-top: 2px;
        padding-bottom: 2px;
    }
}

@media (max-width: 690px) {
    .finish-content {
        padding: 36.8px 18.4px 46px;
    }

    .finish-repurchase {
        flex-wrap: wrap;
        gap: 9.2px 13.8px;
        margin-top: 34.5px;
        padding: 13.8px 18.4px;
    }

    .finish-repurchase p {
        flex: 1;
        text-align: left;
    }

    .finish-repurchase .finish-link {
        flex-basis: 100%;
        min-height: 41.4px;
    }

    .finish-help-inner {
        grid-template-columns: 1fr;
        max-width: 404.8px;
    }

    .finish-help-item,
    .finish-help-item + .finish-help-item {
        justify-content: flex-start;
        padding: 13.8px 0;
        border-left: 0;
    }

    .finish-help-item + .finish-help-item {
        margin-top: 9.2px;
        padding-top: 23px;
        border-top: 1px solid #d8dbe5;
    }

    .finish-desktop-break {
        display: none;
    }
}
</style>
